import { render, staticRenderFns } from "./apd_F.vue?vue&type=template&id=99c4c89c"
import script from "./apd_F.vue?vue&type=script&lang=js"
export * from "./apd_F.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports